import React from 'react';
import { Table, flexRender } from '@tanstack/react-table';
import { Button } from '../../../components/ui/button';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuCheckboxItem,
} from '../../../components/ui/dropdown-menu';
import { ChevronDownIcon, ColumnsIcon } from 'lucide-react';
import { StudyData } from '@/types/types';

interface TableToolbarProps {
  table: Table<StudyData>;
}

export const TableToolbar: React.FC<TableToolbarProps> = ({ table }) => {
  const hasFilters = table.getState().columnFilters.length > 0;
  const headers = table.getHeaderGroups().flatMap((hg) => hg.headers);
  return (
    <div className="flex items-center justify-end lg:px-6">
      <div className="flex items-center gap-2 p-1">
        {hasFilters && (
          <button
            onClick={() => table.resetColumnFilters()}
            className="btn btn-outline mr-2 border rounded-[5px] p-1 pr-2 pl-2"
            aria-label="Clear all filters"
          >
            Clear Filters
          </button>
        )}

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" size="sm" className="rounded">
              <ColumnsIcon />
              <span className="hidden lg:inline">Customize Columns</span>
              <ChevronDownIcon />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-56">
            {table
              .getAllColumns()
              .filter(
                (column) =>
                  typeof column.accessorFn !== 'undefined' &&
                  column.getCanHide()
              )
              .map((column) => {
                const header = headers.find((h) => h.column.id === column.id);
                return (
                  <DropdownMenuCheckboxItem
                    key={column.id}
                    checked={column.getIsVisible()}
                    onCheckedChange={(value) =>
                      column.toggleVisibility(!!value)
                    }
                  >
                    {header
                      ? flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )
                      : typeof column.columnDef.header === 'string'
                      ? column.columnDef.header
                      : null}
                  </DropdownMenuCheckboxItem>
                );
              })}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
};
